export const EducateData = [{
    index: 1,
    heading: "1:1 & In-Salon Training",
    content: [
        `Bespoke education sessions, crafted around your unique needs
        from colour and cutting to textured hair care, consultation skills, and 
        confident retailing.`,

        `These sessions are designed to help you grow in skill and in confidence
        so that when clients sit in your chair, you know exactly how to serve 
        them with care and purpose.`,
    ],
    reasons: [
        `Build confidence with colour and curl`,
        `Offer personalised service with impact`,
        `Elevate client experience and boost retention`,
        `Understand how care connects to turnover and trust`,
    ]
},
{
    index: 2,
    heading: "Mentoring the Future",
    content: [
        `Giving back is part of the KARA brand.`,

        `Alongside paid education, I run a small mentoring circle for apprentices 
        a safe space to support, guide, and uplift the next generation of stylists.`,
        
        `Because this industry gave me purpose when I needed it most 
        and I believe we all have a role in helping young talent grow with confidence 
        and care at the heart.`,
    ]
}]